import request from "@/utils/request";
import { getIntranetHost } from "@/constants";
import {
  FetchUserInfoParams,
  FetchUserInfoResponse,
  UserUnReadMessageResponse,
} from "./types";

/**
 * 用户信息详情
 * @docs: https://api-mock.meitu-int.com/project/1594/interface/api/82889
 */
export const fetchUserInfo = async function () {
  return await request<FetchUserInfoResponse>(
    `${getIntranetHost()}/user/info`,
    {
      method: "GET",
      hideErrorToast: true,
    }
  );
};

export const fetchUnReadMessage = async function (params: any) {
  return await request<UserUnReadMessageResponse>(
    `${process.env.REACT_APP_API_FEEDBACK}/im_v2/unread_count.json`,
    {
      method: "GET",
      data: params,
    }
  );
};
